import {Component,inject,ChangeDetectionStrategy} from '@angular/core';
import {Title} from '@angular/platform-browser';
import {MATERIAL_IMPORTS} from '../shared/material-imports';
import {COMMON_IMPORTS} from '../shared/common-imports';

@Component({
	selector:'app-not-found',
	imports:[
		...MATERIAL_IMPORTS,...COMMON_IMPORTS
	],
	templateUrl:'./not-found.html',
	styleUrl:'./not-found.scss',
	changeDetection:ChangeDetectionStrategy.OnPush
})
export class NotFoundComponent{
	private readonly title=inject(Title);

	constructor(){
		this.title.setTitle('Bendita Administrator - NOT FOUND');
	}
}
